// extracted by mini-css-extract-plugin
module.exports = {"TetherComponent--belowPanel":"TetherComponent--belowPanel__2OGk0"};